var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25979 8.35005L4.01686 6.45737C4.13757 6.1556 4.31832 5.88148 4.54815 5.65166L8.69966 1.50042C9.19672 1.00336 10.0026 1.00336 10.4997 1.50042C10.9967 1.99747 10.9967 2.80336 10.4997 3.30042L6.34815 7.45166C6.11832 7.68148 5.84421 7.86223 5.54243 7.98294L3.64975 8.74001C3.40485 8.83796 3.16183 8.59494 3.25979 8.35005Z",
    fill: "#699BF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09995 3.44999C2.09995 3.03577 2.43574 2.69999 2.84995 2.69999H5.99995C6.24848 2.69999 6.44995 2.49852 6.44995 2.24999C6.44995 2.00146 6.24848 1.79999 5.99995 1.79999H2.84995C1.93868 1.79999 1.19995 2.53872 1.19995 3.44999V9.14999C1.19995 10.0613 1.93868 10.8 2.84995 10.8H8.54995C9.46122 10.8 10.2 10.0613 10.2 9.14999V5.99999C10.2 5.75146 9.99848 5.54999 9.74995 5.54999C9.50142 5.54999 9.29995 5.75146 9.29995 5.99999V9.14999C9.29995 9.5642 8.96417 9.89999 8.54995 9.89999H2.84995C2.43574 9.89999 2.09995 9.5642 2.09995 9.14999V3.44999Z",
    fill: "#699BF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.88cc1085b7d4248363ee6c5809f35561.svg";
export { ForwardRef as ReactComponent };